export const alertView = (data = null, action) => {
    if (action.type === "SHOW_ALERT") {
        return action.payload;
    }
    return data;
};
